import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Cookies from 'js-cookie';
import * as _ from 'underscore';
import * as appConstants from '../constants/appConstants';
import * as appConstantsLocal from '../environments/appConstantsLocal.json';
import * as appConstantsStage from '../environments/appConstantsStage.json';
import * as appConstantsDev from '../environments/appConstantsDev.json';
import * as appConstantsProd from '../environments/appConstantsProd.json';
import sha256 from 'js-sha256';
import DOMPurify from 'dompurify';


import {
    getLabels,
    getUserInfo,
    getAccountsInfo,
    getUserProfile,
    generateCookieData,
    getAdminInfo
} from '../services/webServices';

import UserFormData from './userFormData';

class UserAuthenticate extends Component {
    state = {
        redirectSuccess: '',
        userDetail: '',
        token: '',
        firstName: '',
        fullName: '',
        lastName: '',
        userName: '',
        emailId: '',
        expires_in: '',
        isLoading: false
    };
    constructor(props) {
        super(props)
        this.onClickSwitchAccount = this.onClickSwitchAccount.bind(this);
        this.OnClickContinueWithoutLogin = this.OnClickContinueWithoutLogin.bind(this);
        this.onClickCreatePublicAccount = this.onClickCreatePublicAccount.bind(this);
        this.onClickSignOut = this.onClickSignOut.bind(this);
        this.label = [];
        this.customBaseUrl = '';
        this.domain = '';
        this.contactUser = '';
        this.redirectUrlWithDefaultParameters = '';
        this.cartId = '';
    }

   async componentDidMount() {
    // Get the hostname of the current URL
    let hostname = window.location.hostname;
    // Set the isLoading state to true
    this.setState({
        isLoading: true
    });
    // Determine which set of app constants to use based on the hostname
    if ((hostname === 'preview.esri.com') || (hostname === 'preview-support.esri.com')) {
        console.log("this is for preview constants");
        this.appConstantsData = appConstantsProd.default;
    } else if (hostname.includes('uat') ) {
        console.log("this is for UAT constants");
        this.appConstantsData = appConstantsStage.default;
    } else if (hostname === 'aem-dev.esri.com') {
        console.log("this is for dev constants");
        this.appConstantsData = appConstantsDev.default;
    } else if (hostname.includes('localhost')) {
        console.log("this is for local constants");
        this.appConstantsData = appConstantsLocal.default;
    } else {
        console.log("this is for prod constants");
        this.appConstantsData = appConstantsProd.default;
    }
    // Parse the query parameters from the URL
    let searchParams = new URLSearchParams(this.props.location.search);
    let redirectSuccessQueryString = searchParams.get('redirect_success');
    let hashValue = window.location.hash.split('&');
    let accessToken = hashValue && hashValue[0] && hashValue[0].split('=');
    let tokenExpires = hashValue && hashValue[1] && hashValue[1].split('=');
    let userName = hashValue && hashValue[2] && hashValue[2].split('=');
    let redirectSuccessArr = redirectSuccessQueryString && redirectSuccessQueryString.split('?');
    let redirectSuccess = redirectSuccessArr && redirectSuccessArr[0];
    // Extract domain from redirectSuccess
    let redirectSuccessDomain = '';
    if (redirectSuccess && (redirectSuccess.startsWith('http://') || redirectSuccess.startsWith('https://'))) {
        redirectSuccessDomain = new URL(redirectSuccess).hostname;
    } 
    let queryParameterArr = redirectSuccessArr && redirectSuccessArr[1] && redirectSuccessArr[1].split('=');
    if (queryParameterArr && queryParameterArr[0] === 'cartId') {
        this.cartId = queryParameterArr[1];
    }
    // Build redirect Success URL with query parameters
    if (redirectSuccessArr && redirectSuccessArr[1]) { 
        redirectSuccess = redirectSuccess + '?' + redirectSuccessArr[1]; // passing query parameters from redirectsucess to target url
    } 

    //updating default redirect success url
    if (redirectSuccess) { 
        this.appConstantsData.defaultRedirectSuccess = redirectSuccess;
    } else if(document.referrer){
        redirectSuccess = document.referrer;
        this.appConstantsData.defaultRedirectSuccess = document.referrer;
    } 

    let pathName = window.location.pathname.split('/');
    let userLanguage = pathName[1];
    this.domain = hostname.substring(hostname.indexOf("."));

    // If on an esri.com domain, but redirectSuccess is not, user is redirected to esri.com
    if (hostname.endsWith('.esri.com') && !(redirectSuccessDomain && redirectSuccessDomain.endsWith('.esri.com'))) {
        window.location.href = this.appConstantsData.homePage;
    }

    this.redirectUrlWithDefaultParameters = this.appConstantsData.loginUrl + '?client_id=' + this.appConstantsData.clientId + '&response_type=' + this.appConstantsData.responseType + '&showSignupOption=' + this.appConstantsData.showSignupOption + '&signuptype=' + this.appConstantsData.signupType + '&hideCancel=' + this.appConstantsData.hideCancel + '&locale=' + this.appConstantsData.locale + '&redirect_uri=' + window.location.origin + window.location.pathname + '?redirect_success=' + this.appConstantsData.defaultRedirectSuccess + '&expiration=' + this.appConstantsData.defaultExpiration;
    // Redirect to the default URL if any of the required parameters are missing
    if (!redirectSuccess || !(accessToken && accessToken[1]) || !(tokenExpires && tokenExpires[1]) || !(userName && userName[1])) {
        window.location.replace(this.redirectUrlWithDefaultParameters);
    } else {
        // Set the state with the retrieved parameters
        this.setState(
            {
                token: accessToken[1],
                redirectSuccess: redirectSuccess,
                expires_in: tokenExpires[1],
                userName: userName[1]
            }
        );
        // Get label data and validate user details
        await this.getLabelData(userLanguage);
        this.validateUserDetails(accessToken[1]);
    }
    // Append the access token to the redirect success URL if the path includes 'oauth2'
    if (window.location.pathname.includes('oauth2')){
        this.setState({
            redirectSuccess: redirectSuccess + this.props.location.hash.replace('#access_', redirectSuccess.indexOf('?') > 1 ? '&' : '?')
        });
    }
};

    timedRedirect (url, time)
    {
        setTimeout(function() {
            console.log("redirecting to " + url);    
            window.location.replace(url);
          }, time);
    }

    async getLabelData(userLanguage) {
        let rawData = await getLabels(userLanguage, this.appConstantsData.labelDataApi);
        this.label = rawData.data["jcr:content"].data.master;
    }


    async validateUserDetails(accessToken) {
        let userDetailsToDisplay = '';

        try {
            let userinfoResponse = await getUserInfo(accessToken, this.appConstantsData.selfApi);
            let userInfoError = userinfoResponse.data.error;

            if (userInfoError && userInfoError.message) {
                userDetailsToDisplay = (
                    <div className="userErrorDiv">
                        <p className="userError">{userInfoError.message}</p>
                    </div>
                );
                this.setState({
                    userDetail: userDetailsToDisplay
                });
                window.location.replace(this.redirectUrlWithDefaultParameters);

            } else if (!_.isEmpty(userinfoResponse.data.user)) {
                let userDetails = userinfoResponse.data.user;
                let firstName = userDetails.firstName;
                let lastName = userDetails.lastName;
                let fullName = userDetails.fullName;
                let emailId = userDetails.email;
                let urlKey = userinfoResponse.data.urlKey;
                let userAccess = userDetails.access;
                let userSubscriptionID = userinfoResponse.data.subscriptionInfo?.id;          

                if (userinfoResponse.data.contacts) {
                    this.contactUser = userinfoResponse.data.contacts[0];
                }
            
                
                if (urlKey && userAccess === 'org') {
                    this.customBaseUrl = urlKey + "."+ userinfoResponse.data.customBaseUrl;
                }
                this.setState({
                    firstName, lastName, emailId, fullName
                });


                this.verifyUserAccountInfo(userDetails, accessToken, userSubscriptionID);
            } else {
                userDetailsToDisplay = (
                    <div className="userErrorDiv">
                        <p claseName="userError">Something went wrong, unable to fetch user data</p>
                    </div>
                );
                this.setState({
                    userDetail: userDetailsToDisplay,
                    isLoading: false
                });
            }
        } catch (error) {
            userDetailsToDisplay = (
                <div claseName="userErrorDiv">
                    <p claseName="userError">{error}</p>
                </div>
            );
            this.setState({
                userDetail: userDetailsToDisplay
            });
        }
    }

    onClickSwitchAccount() {
        let manageAccountUrl;
        if(this.customBaseUrl){
            manageAccountUrl = "https://"+ this.customBaseUrl+this.appConstantsData.manageOrgAccountUrl;
        }else{
            manageAccountUrl = this.appConstantsData.manageAccountUrl;
        }
        let switchAccountApiEndpoint =  manageAccountUrl + '#redirect_uri='+ window.location.origin + window.location.pathname +'?redirect_success=' + this.state.redirectSuccess + '&client_id=' + this.appConstantsData.clientId;
        window.location.replace(switchAccountApiEndpoint);
    }

    OnClickContinueWithoutLogin() {
        window.location.replace(this.state.redirectSuccess);
    }

    onClickCreatePublicAccount() {
        let signUpToPublicAccountURL = this.appConstantsData.SignUpPublicAccountUrl + '?client_id=' + this.appConstantsData.clientId + '&redirect_uri=' + this.state.redirectSuccess + '&state=' + this.state.token + '&response_type=token';
        window.location.replace(signUpToPublicAccountURL);
    }

    onClickSignOut() {
        let signOutURL = window.location.origin + '/en-us/signout?redirect_uri=' + this.state.redirectSuccess;
        window.location.replace(signOutURL);
    }

    async verifyUserAccountInfo(userDetails, token, userSubscriptionID) {
        let linkedUsers = [];
        let userDetailsToDisplay = '';
        let userType = userDetails && userDetails.userType ? userDetails.userType : '';
        let userName = userDetails && userDetails.username ? userDetails.username : this.state.userName;
        let adminAccess = false;
        let adminFullName;
        let adminEmail;


        if (userType === "arcgisonly") {
            try {
                let accounts = await getAccountsInfo(userName, token, this.appConstantsData.linkedUserUrl);
                linkedUsers = accounts.data.linkedUsers;
                let adminUsers = await getAdminInfo(token, this.appConstantsData.usersApi);
                let users = adminUsers.data.users;
                if (users && this.contactUser) {
                    for (var i = 0; i < adminUsers.data.total; i++) {
                        if (users[i].username === this.contactUser) {
                            adminFullName = users[i].fullName;
                            adminEmail = users[i].email;
                            adminAccess = true;
                        }
                    }
                }

                // linkedUsers[0] = 'arcgisonly';
                if (linkedUsers && linkedUsers.length > 0) {
                    let linkedUsersArcgisNotOnly = _.filter(linkedUsers, function (data) {
                        return data.userType !== appConstants.userType;
                    });
                    if (linkedUsersArcgisNotOnly && linkedUsersArcgisNotOnly.length > 0) {
                        userDetailsToDisplay = (

                            <div className="calcite-container" >
                                <div className="grid-container">
                                    <div className="columnsystem">
                                        <div className="column-12 pre-6">
                                            <div className="text parbase">
                                                {this.label.noAccessMessage}
                                                <span className="font-size-2">{decodeURIComponent(this.state.userName)}</span>
                                                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.label.documentationLabel) }} />
                                                <div className="column-6">
                                                    <div className="cta-buttons">

                                                        <div className="calcite-cta">
                                                            <calcite-button appearance="solid" color="blue" scale="m" onClick={this.onClickSignOut} alignment="center" width="auto" calcite-hydrated="">
                                                                {this.label.signOutLabel}
                                                            </calcite-button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {adminAccess && <div className="column-6">
                                                    <p>{this.label.adminAccessLabel}</p>
                                                    {adminFullName} <br></br>
                                                    <a className="link-blue" href={`mailto:${adminEmail}`}>{adminEmail}</a>
                                                </div>
                                                }
                                            </div>
                                            <div className="column-12 leader-half">
                                                <hr className="solid"></hr>
                                                <div className="text column-3">
                                                    <p>{this.label.otherOptionsLabel}</p>
                                                </div>
                                                <div className="cta-buttons">
                                                    <div className="calcite-cta">
                                                        <div className="column-5">
                                                            <calcite-link color="blue" scale="m" onClick={this.onClickSwitchAccount} icon-end="link" alignment="center" width="auto" calcite-hydrated="">
                                                                {this.label.switchAccountLabel}
                                                            </calcite-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                        this.setState({
                            isLoading: false
                        });
                    } else {
                        userDetailsToDisplay = (
                            <div className="calcite-container" >
                                <div className="grid-container">
                                    <div className="columnsystem">

                                        <div className="column-12 pre-6">
                                            <div className="text parbase">
                                                {this.label.noAccessMessage}
                                                <span className="font-size-2">{decodeURIComponent(this.state.userName)}</span>
                                                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.label.documentationLabel) }} />
                                                <div className="column-6">
                                                    <div className="cta-buttons">

                                                        <div className="calcite-cta">
                                                            <calcite-button appearance="solid" color="blue" scale="m" onClick={this.onClickSignOut} alignment="center" width="auto" calcite-hydrated="">
                                                                {this.label.signOutLabel}
                                                            </calcite-button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {adminAccess && <div className="column-6">
                                                    <p>{this.label.adminAccessLabel}</p>
                                                    {adminFullName} <br></br>
                                                    <a className="link-blue" href={`mailto:${adminEmail}`}>{adminEmail}</a>
                                                </div>
                                                }
                                            </div>
                                            <div className="column-12 leader-half">
                                                <hr className="solid"></hr>
                                                <div className="text column-3">
                                                    <p>{this.label.otherOptionsLabel}</p>
                                                </div>
                                                <div className="cta-buttons">
                                                    <div className="calcite-cta">
                                                        <div className="column-5">
                                                            <calcite-link color="blue" scale="m" onClick={this.onClickSwitchAccount} icon-end="link" alignment="center" width="auto" calcite-hydrated="">
                                                                {this.label.accountLinkLabel}
                                                            </calcite-link>
                                                        </div>
                                                        <div className="column-4">
                                                            <calcite-link color="blue" scale="m" onClick={this.onClickCreatePublicAccount} icon-end="arrowRight" width="auto" calcite-hydrated="">
                                                                {this.label.createNewAccount}
                                                            </calcite-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    this.setState({
                        userDetail: userDetailsToDisplay,
                        isLoading: false
                    });

                } else {
                    userDetailsToDisplay = (
                        <div className="calcite-container" >
                            <div className="grid-container">
                                <div className="columnsystem">

                                    <div className="column-12 pre-6">
                                        <div className="text parbase">
                                            {this.label.noAccessMessage}
                                            <span className="font-size-2"> {decodeURIComponent(this.state.userName)}</span>
                                            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.label.documentationLabel) }} />
                                            <div className="column-6">
                                                <div className="cta-buttons">

                                                    <div className="calcite-cta">
                                                        <calcite-button appearance="solid" color="blue" scale="m" onClick={this.onClickSignOut} alignment="center" width="auto" calcite-hydrated="">
                                                            {this.label.signOutLabel}
                                                        </calcite-button>
                                                    </div>
                                                </div>
                                            </div>
                                            {adminAccess && <div className="column-6">
                                                <p>{this.label.adminAccessLabel}</p>
                                                {adminFullName} <br></br>
                                                <a className="link-blue" href={`mailto:${adminEmail}`}>{adminEmail}</a>
                                            </div>
                                            }
                                        </div>
                                        <div className="column-12 leader-half">
                                            <hr className="solid"></hr>
                                            <div className="text column-3">
                                                <p>{this.label.otherOptionsLabel}</p>
                                            </div>
                                            <div className="cta-buttons">
                                                <div className="calcite-cta">
                                                    <div className="column-5">
                                                        <calcite-link color="blue" scale="m" onClick={this.onClickSwitchAccount} icon-end="link" alignment="center" width="auto" calcite-hydrated="">
                                                            {this.label.accountLinkLabel}
                                                        </calcite-link>
                                                    </div>
                                                    <div className="column-4">
                                                        <calcite-link color="blue" scale="m" onClick={this.onClickCreatePublicAccount} icon-end="arrowRight" width="auto" calcite-hydrated="">
                                                            {this.label.createNewAccount}
                                                        </calcite-link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                    this.setState({
                        userDetail: userDetailsToDisplay,
                        isLoading: false
                    });

                }

            } catch (error) {
                userDetailsToDisplay = (
                    <div claseName="userErrorDiv">
                        <p claseName="userError">{error}</p>
                    </div>
                );
                this.setState({
                    userDetail: userDetailsToDisplay
                });
            }

        } else {

            try {
                let userProfile = {};
                let updateLastLogin = true;  
            
                // this is to speedup profile call for UC
                if((this.state.redirectSuccess.indexOf("event.esri.com") >= 1)|| (this.state.redirectSuccess.indexOf("rainfocus.com") >= 1)){
                    updateLastLogin = false; 
                }
                if (updateLastLogin) {
                    let profileData = await getUserProfile(token, userName, this.appConstantsData.profileApi, updateLastLogin);
                    userProfile = profileData.data.getProfileResponse;
                }else{
                    await getUserProfile(token, userName, this.appConstantsData.profileApi, updateLastLogin);
                    userProfile.FirstName = this.state.firstName;
                    userProfile.LastName = this.state.lastName;
                    userProfile.PrimaryEmail = this.state.emailId;
                }
                
                this.setState({
                    isLoading: false
                });

                let cookieObj = {};
                let currentData = Date.now()

                let CookieExpiration = new Date(currentData).getTime() + new Date(this.state.expires_in * 1000).getTime(); //this is for expiration value inside cookie
                let expirationDate = new Date(currentData + this.state.expires_in * 1000); //this is for cookie expiration
                cookieObj.token = token;
                cookieObj.userName = userName;
                cookieObj.expires = CookieExpiration;
                cookieObj.customBaseUrl = this.customBaseUrl;


                //checking subscription ID for Employee and hide FUEL fields form
                if ((userProfile && userProfile.FirstName && userProfile.LastName && userProfile.PrimaryEmail) || appConstants.subscriptionIDs.includes(userSubscriptionID)) {
                    cookieObj.firstName = userProfile.FirstName;
                    cookieObj.lastName = userProfile.LastName;
                    cookieObj.email = userProfile.PrimaryEmail;
                    cookieObj.hashedEmail = sha256(userProfile.PrimaryEmail);   

                    let cookieData = generateCookieData(cookieObj);
                    let eCommCartId = Cookies.get('eCommCartId');
                    
                    let secureOption='';
                    if(this.state.redirectSuccess.indexOf("local") <= -1){
                        secureOption = '; secure';
                    }
                    document.cookie = `esri_auth=${cookieData}; expires=${expirationDate.toUTCString()}; path=/; domain=${this.domain}` + secureOption;
                   // Cookies.set('esri_auth', cookieData, { expires: expirationDate, path: '/', domain: this.domain });
                    if (this.cartId && !eCommCartId) {
                        Cookies.set('eCommCartId', this.cartId, { expires: expirationDate, path: '/', domain: this.domain });
                    }
                    window.location.replace(this.state.redirectSuccess);
                } else {
                    console.log("label", this.label)
                    let updateUserData = (
                        <UserFormData
                            labelData={this.label}
                            redirectSuccess={this.state.redirectSuccess}
                            domain={this.domain}
                            secureOption={this.secureOption}
                            expirationDate={expirationDate}
                            cookieObj={cookieObj}
                            cartId={this.cartId}
                            profileApi={this.appConstantsData.profileApi}
                        />
                    );

                    this.setState({
                        updateUserData: updateUserData
                    });

                }

            } catch (error) {
                console.log("error in updating profile", error)
               // this.timedRedirect (this.state.redirectSuccess,10000);
            }

        }
    }

    render() {
        return (
            <div>
                {this.state.isLoading &&
                    <calcite-loader
                        active=""
                        type="indeterminate"
                        scale="m"
                        value="0"
                        id="ab2257c8-8c9f-972c-3aaa-149c389f236f"
                        role="progressbar"
                    ></calcite-loader>
                }
                <div clase="userAuth">
                    {this.state.userDetail}
                </div>
                {this.state.updateUserData}
            </div>
        );
    }
}

export default withRouter(UserAuthenticate);